import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { isRenderingForMobileApp } from 'src/constants';
import { environment } from 'src/environments/environment';
import { sortBy } from 'lodash';
// import { ContenfulCategory } from 'src/app/shared/models';
// import { ContentfulService } from 'src/app/shared/services';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'zip-co-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  public showSlideMenu = false;
  public showDropDown = false;
  public dropDownIsHiding = false;
  public signinUrl: string;
  public signUpUrl: string;
  public showZipBiz: boolean;
  public isMobileRender = isRenderingForMobileApp;
  openSub: boolean;

  @Input()
  public showBackButton = false;

  @Output()
  public readonly back = new EventEmitter<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router, // private contentfulService: ContentfulService,
  ) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (val.url.includes('/zipbusiness')) {
          this.signinUrl = `${environment.auth.zipBusinessLogin}`;
          this.signUpUrl = `${environment.auth.zipBusinessSignup}`;
          this.showZipBiz = true;
        } else {
          this.showZipBiz = false;
        }
      }
    });
  }

  public get shopLink(): string {
    return environment.shopUrl.shopRouteLink;
  }

  // Using arrow function to allow this context inside of
  // native addEventListener function
  toggleDropDown = () => {
    if (!this.showDropDown) {
      this.showDropDown = true;
      window.addEventListener('click', this.toggleDropDown);
    } else {
      window.removeEventListener('click', this.toggleDropDown);
      this.dropDownIsHiding = true;
      setTimeout(() => {
        this.showDropDown = false;
        this.dropDownIsHiding = false;
      }, 200);
    }
  };

  // Using arrow function to allow this context inside of
  // native addEventListener function
  toggleSlideMenu = () => {
    if (!this.showSlideMenu) {
      this.showSlideMenu = true;
      this.toggleBodyScroll(!this.showSlideMenu);
      window.addEventListener('click', this.toggleSlideMenu);
    } else {
      this.showSlideMenu = false;
      this.toggleBodyScroll(!this.showSlideMenu);
      window.removeEventListener('click', this.toggleSlideMenu);
    }
  };

  toggleBodyScroll(enabled = true): void {
    if (enabled) {
      document.body.classList.remove('no-scroll');
    } else {
      document.body.classList.add('no-scroll');
    }
  }

  async ngOnInit() {}
}
